import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { resolveAdminLandingPath } from '../../admin/utils/adminNavigation';

const AdminChangePassword = () => {
  const navigate = useNavigate();
  const { user, changePassword, hasPermission, isSuperAdmin } = useAdminAuth();
  const [form, setForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!form.currentPassword || !form.newPassword) {
      setError('Current password and new password are required.');
      return;
    }
    if (form.newPassword.length < 8) {
      setError('New password must be at least 8 characters.');
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setError('New password and confirm password must match.');
      return;
    }

    try {
      setLoading(true);
      await changePassword(form.currentPassword, form.newPassword);
      navigate(resolveAdminLandingPath({ user: { ...user, mustChangePassword: false }, hasPermission, isSuperAdmin }), {
        replace: true,
      });
    } catch (err) {
      setError(err.message || 'Unable to change password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-xl rounded-[28px] border border-[color:var(--admin-border)] bg-white p-6 shadow-sm">
      <div>
        <p className="text-xs uppercase tracking-[0.28em] text-[color:var(--admin-icon)]">Security</p>
        <h1 className="mt-2 text-2xl font-semibold text-[color:var(--admin-heading)]">Change Password</h1>
        <p className="mt-2 text-sm text-[color:var(--admin-text)]">
          Update your password before continuing in the admin panel.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="mt-6 space-y-4">
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-[color:var(--admin-icon)]">Current password</label>
          <input
            type="password"
            value={form.currentPassword}
            onChange={(event) => setForm((prev) => ({ ...prev, currentPassword: event.target.value }))}
            className="mt-2 w-full rounded-2xl border border-[color:var(--admin-border)] px-4 py-3 text-sm outline-none focus:border-[var(--admin-accent)]"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-[color:var(--admin-icon)]">New password</label>
          <input
            type="password"
            value={form.newPassword}
            onChange={(event) => setForm((prev) => ({ ...prev, newPassword: event.target.value }))}
            className="mt-2 w-full rounded-2xl border border-[color:var(--admin-border)] px-4 py-3 text-sm outline-none focus:border-[var(--admin-accent)]"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-[color:var(--admin-icon)]">Confirm password</label>
          <input
            type="password"
            value={form.confirmPassword}
            onChange={(event) => setForm((prev) => ({ ...prev, confirmPassword: event.target.value }))}
            className="mt-2 w-full rounded-2xl border border-[color:var(--admin-border)] px-4 py-3 text-sm outline-none focus:border-[var(--admin-accent)]"
          />
        </div>
        {error && (
          <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-600">
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={loading}
          className="rounded-full bg-[var(--admin-accent)] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#0d504e] disabled:opacity-60"
        >
          {loading ? 'Updating...' : 'Update password'}
        </button>
      </form>
    </div>
  );
};

export default AdminChangePassword;
